<p-toast position="top-right" styleClass="toast-personalized"></p-toast>
<p-toast key="loading" position="top-right" styleClass="toast-personalized"></p-toast>
